/**
 * 중앙 집중식 URL 관리
 * 개발/배포 환경을 고려한 URL 설정
 */

// API Base URL (기존과 동일)
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// 서버 Base URL (파일 서빙용)
export const SERVER_BASE_URL = process.env.REACT_APP_SERVER_URL || 'http://localhost:5000';

/**
 * 파일 URL 생성 함수들
 */

/**
 * 영수증 이미지 URL 생성
 * @param {string} receiptPath - DB에 저장된 영수증 경로 (예: "/uploads/receipts/filename.jpg")
 * @returns {string} 전체 URL
 */
export const getReceiptUrl = (receiptPath) => {
    if (!receiptPath) return null;
    
    // 이미 전체 URL인 경우 그대로 반환
    if (receiptPath.startsWith('http://') || receiptPath.startsWith('https://')) {
        return receiptPath;
    }
    
    // 상대 경로인 경우 서버 URL과 결합
    return `${SERVER_BASE_URL}${receiptPath}`;
};

/**
 * 첨부파일 URL 생성 (프로젝트 거래 등)
 * @param {string} attachmentPath - DB에 저장된 첨부파일 경로
 * @returns {string} 전체 URL
 */
export const getAttachmentUrl = (attachmentPath) => {
    if (!attachmentPath) return null;
    
    // 이미 전체 URL인 경우 그대로 반환
    if (attachmentPath.startsWith('http://') || attachmentPath.startsWith('https://')) {
        return attachmentPath;
    }
    
    // 상대 경로인 경우 서버 URL과 결합
    return `${SERVER_BASE_URL}${attachmentPath}`;
};

/**
 * 일반 파일 URL 생성
 * @param {string} filePath - DB에 저장된 파일 경로
 * @returns {string} 전체 URL
 */
export const getFileUrl = (filePath) => {
    if (!filePath) return null;
    
    // 이미 전체 URL인 경우 그대로 반환
    if (filePath.startsWith('http://') || filePath.startsWith('https://')) {
        return filePath;
    }
    
    // 상대 경로인 경우 서버 URL과 결합
    return `${SERVER_BASE_URL}${filePath}`;
};

/**
 * 환경별 설정
 */
export const URL_CONFIG = {
    development: {
        API_BASE: 'http://localhost:5000/api',
        SERVER_BASE: 'http://localhost:5000'
    },
    production: {
        API_BASE: 'https://erp.safesignal.cloud/api',
        SERVER_BASE: 'https://erp.safesignal.cloud'
    }
};

/**
 * 현재 환경에 맞는 URL 가져오기
 */
export const getCurrentConfig = () => {
    const env = process.env.NODE_ENV || 'development';
    return URL_CONFIG[env] || URL_CONFIG.development;
};